import React from 'react'
import { Grid, Skeleton, csx } from '@vtex/admin-ui'

import {
  ProductImage,
  PRODUCT_IMAGE_WIDTH_DESKTOP,
  PRODUCT_IMAGE_WIDTH_MOBILE,
} from '../../../../components'

export type CartItemSkeletonProps = {
  item: {
    name?: string
    imageUrl?: string
  }
}

export const CartItemSkeleton = ({ item }: CartItemSkeletonProps) => (
  <Grid
    data-testid="cart-item-skeleton"
    gap="4"
    className={csx({
      gridTemplateColumns: `${PRODUCT_IMAGE_WIDTH_MOBILE}px auto`,
      '@desktop': {
        gridTemplateColumns: `${PRODUCT_IMAGE_WIDTH_DESKTOP}px auto`,
      },
    })}
  >
    <ProductImage src={item.imageUrl} alt={item.name ?? ''} sizeInPx={120} />
    <div
      className={csx({
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '1rem',
        flex: 1,
      })}
    >
      <p
        className={csx({
          fontVariationSettings: "'WGHT' 600 !important",
          '@desktop': {
            fontSize: '1.25rem',
          },
        })}
      >
        {item.name}
      </p>
      <Skeleton
        className={csx({
          height: '0.625rem',
          width: '9.375rem',
          marginTop: '$space-3',
        })}
      />
    </div>
  </Grid>
)
